import { render, staticRenderFns } from "./score_geo_rule_mgr.vue?vue&type=template&id=7e51b51c&"
import script from "./score_geo_rule_mgr.vue?vue&type=script&lang=js&"
export * from "./score_geo_rule_mgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports